import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import {
  CurrencyComponent,
  DateComponent,
  getColumnKey,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { isNotNil } from '@web/utils';
import { SubscriptionStatusComponent } from '@web/shared/module/shop';
import { AdminSubscriptionCollectionItem } from '../../models/admin-subscription-collection-item';
import { AdminSubscriptionCollectionFilter } from '../../models/admin-subscription-collection-filter';

@Component({
  selector: 'app-admin-subscription-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    CurrencyComponent,
    SubscriptionStatusComponent,
    NoDataComponent,
    DateComponent,
  ],
  templateUrl: './admin-subscription-list-custom-cell-template.component.html',
  styleUrl: './admin-subscription-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminSubscriptionListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminSubscriptionCollectionItem, AdminSubscriptionCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminSubscriptionCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminSubscriptionCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
